import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const AgentNameValidatorUiOptionsSchema = z.object({
  debounceMs: z.number().optional().describe('Debounce delay in milliseconds'),
  isEditMode: z
    .boolean()
    .optional()
    .describe('Whether the field is in edit mode'),
});

// Transforms the Zod schema to a TypeScript type
export type AgentNameValidatorUiOptions = z.infer<
  typeof AgentNameValidatorUiOptionsSchema
>;

/* The field schema for the AgentNameValidator field extension */
export const AgentNameValidatorFieldSchema = makeFieldSchemaFromZod(
  z.string().describe('Agent Name Validator'),
  AgentNameValidatorUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type AgentNameValidatorProps = typeof AgentNameValidatorFieldSchema.type;

/* The final custom field extension schema used for the field extension */
export const AgentNameValidatorSchemaFinal =
  AgentNameValidatorFieldSchema.schema;

// Legacy export for backward compatibility (if needed)
export const AgentNameValidatorSchema = AgentNameValidatorFieldSchema.schema;
